"use strict";
function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
exports.tryFunctionOrLogError = tryFunctionOrLogError;
//# sourceMappingURL=errorHandling.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/apollo-client/util/errorHandling.js
 ** module id = 468
 ** module chunks = 0
 **/